import * as React from 'react'
import { useTranslation } from 'hooks'
import PasswordCondition from './PasswordCondition'
import * as S from './PasswordConditions.styles'

const PasswordConditions: React.FC<PasswordConditionsProps> = ({
  password,
  focused,
  errorMessage,
  hasAllPassed
}) => {
  const [allPassed, setAllPassed] = React.useState(false)

  const { t } = useTranslation()

  const has8Chars = (str: string) => str?.length >= 8
  const hasLowercase = (str: string) => /[a-z]/g.test(str)
  const hasNumber = (str: string) => /[0-9]/g.test(str)
  const hasSpecial = (str: string) => /[^A-Za-z0-9]/g.test(str)
  const hasUppercase = (str: string) => /[A-Z]/g.test(str)

  React.useEffect(() => {
    if (
      has8Chars(password) &&
      hasLowercase(password) &&
      hasNumber(password) &&
      hasSpecial(password) &&
      hasUppercase(password)
    ) {
      setAllPassed(true)
      hasAllPassed(true)
    } else {
      setAllPassed(false)
      hasAllPassed(false)
    }
  }, [password, hasAllPassed])

  const boolToStatus = (boolean: boolean) => {
    if (boolean) {
      return 'satisfied'
    }

    if (password !== undefined && password === '') return 'unsatisfied'
    return focused ? 'unsatisfied' : 'error'
  }

  return (
    <S.Container>
      {errorMessage ? (
        <PasswordCondition status="error" message={errorMessage} />
      ) : (
        <>
          <S.InstructionLabel
            status={boolToStatus(allPassed)}
            className="footnote"
          >
            {t('react_components.passwords.must_contain')}
          </S.InstructionLabel>
          <S.Grid className={`grid grid--two`}>
            <PasswordCondition
              status={boolToStatus(has8Chars(password))}
              message={t('react_components.passwords.characters')}
            />
            <PasswordCondition
              status={boolToStatus(hasLowercase(password))}
              message={t('react_components.passwords.lowercase')}
            />
            <PasswordCondition
              status={boolToStatus(hasNumber(password))}
              message={t('react_components.passwords.number')}
            />
            <PasswordCondition
              status={boolToStatus(hasSpecial(password))}
              message={t('react_components.passwords.special')}
            />
            <PasswordCondition
              status={boolToStatus(hasUppercase(password))}
              message={t('react_components.passwords.uppercase')}
            />
          </S.Grid>
        </>
      )}
    </S.Container>
  )
}

export default PasswordConditions

interface PasswordConditionsProps {
  password: string
  focused: boolean
  errorMessage: string
  hasAllPassed: (passed: boolean) => void
}
